import * as React from "react";
import Dialog from "../Dialog";

import InviteUserForm, { InvitePatientFields } from "../../../components/Forms/InviteUserForm";

interface Props {
    onSubmit: (fields: InvitePatientFields) => any;
    handleSubmit?: React.FormEventHandler<any>;
    onCloseDialog: () => any;
    doctor: boolean;
}

interface State {
}

const s = require("./InviteUserDialog.scss");

class InviteUserDialog extends React.Component<Props, State> {
    render(): JSX.Element {
        return (
            <Dialog
                onCloseDialog={this.props.onCloseDialog}
            >
                <InviteUserForm
                    onSubmit={this.props.onSubmit}
                    onCloseDialog={this.props.onCloseDialog}
                    doctor={this.props.doctor}
                />
            </Dialog>
        );
    }
}

export default InviteUserDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/InviteUserDialog/index.tsx